import owaCalendarStrings from 'owa-strings/owa-calendar-strings';
import ReminderOptionType from '../helpers/ReminderOptionType';

/**
 * ReminderOptionType for None reminder option.
 * This is kept separately from the rest of the reminder options because it violates the
 * order of reminders for all day reminders where a reminder in the future
 * (value: <-1) is placed after none (value: -1)
 */
export const reminderOptionNone = {
    key: -1,
    text: owaCalendarStrings.noReminder,
} as ReminderOptionType;

/**
 * Contains all the base options for the reminder dropdown for all day events
 * None is specifically not included in the list, but rather added separately at the start of the list in createReminderDropdownOptions.
 * The localized strings will be generated in createReminderDropdownOptions and createReminderDropdownOptionsForSettings.
 */
export const allDayReminderDropdownOptions: ReminderOptionType[] = [
    { key: -1 * 60 * 9, text: '' }, // Day of event at 9:00 AM
    { key: 60 * 7, text: '' }, // Day before at 5:00 PM
    { key: 60 * 24 * 7 - 60 * 9, text: '' }, // 1 week before at 9:00 AM
];

/**
 * Contains all the base options for the reminder dropdown.
 * None is specifically not included in the list, but rather added separately at the start of the list in createReminderDropdownOptions.
 * The localized strings will be generated in createReminderDropdownOptions and createReminderDropdownOptionsForSettings.
 */
export const nonAllReminderDropdownOptions: ReminderOptionType[] = [
    { key: 0, text: '' }, // At time of event
    { key: 5, text: '' }, // 5 minutes before
    { key: 15, text: '' }, // 15 minutes before
    { key: 30, text: '' }, // 30 minutes before
    { key: 60, text: '' }, // 1 hour before
    { key: 60 * 12, text: '' }, // 12 hours before
    { key: 60 * 24, text: '' }, // 1 day before
    { key: 60 * 24 * 7, text: '' }, // 1 week before
];
